export interface Article {
  id: string;
  title: string;
  slug: string;
  summary: string;
  content: string;
  category: string;
  categoryName: string;
  imageUrl: string;
  tags: string[];
  source: string;
  date: string;
  views: number;
  hot: boolean;
  featured: boolean;
}

const c1 = '<h2>京东618大促：家用电器白菜价低至9.9元</h2><p>京东618年中大促已经全面开启，家电品类迎来年度最低价。本次活动涵盖厨房电器、生活电器、个护电器等多个品类，多款热门商品降至历史最低价。</p><h3>活动亮点</h3><p>本次618活动最大的亮点在于<strong>小家电秒杀专区</strong>，每天10点、14点、20点三个时段开启限量秒杀，多款商品仅需9.9元即可入手。包括小米电热水壶、美的便携风扇、飞科吹风机等热门商品均参与活动。</p><h3>如何参与</h3><p>用户需要提前在活动页面预约心仪商品，到点准时抢购。建议提前设置好收货地址和支付方式，缩短下单时间。每人每天限购一件秒杀商品，部分商品需要叠加平台优惠券才能享受最低价。</p><h3>推荐商品</h3><p>强烈推荐以下几款白菜价商品：小米电热水壶1.5L仅售9.9元（限量1000件）、美的台立两用风扇19.9元、飞科负离子吹风机29.9元、九阳迷你榨汁机39.9元。这些商品日常售价均在50-200元区间，现在是入手的最佳时机。</p>';

const c2 = '<h2>拼多多百亿补贴再升级：iPhone 15系列直降1500元</h2><p>拼多多百亿补贴再度加码，iPhone 15全系参与补贴活动，价格创下新低。这次活动覆盖了iPhone 15、iPhone 15 Plus、iPhone 15 Pro、iPhone 15 Pro Max四款机型。</p><h3>具体价格</h3><p>iPhone 15 128GB版本补贴后价格仅为<strong>4499元</strong>，相比苹果官网5999元的售价直降1500元。iPhone 15 Pro 128GB版本补贴后6499元起，相比官网7999元也是大幅优惠。</p><h3>购买建议</h3><p>对于想换新iPhone的用户来说，这绝对是一个不容错过的白菜价机会。拼多多百亿补贴的商品均为正品国行，享受苹果官方保修服务。建议优先选择标注"百亿补贴"官方标识的店铺购买，确保商品质量和售后服务。</p>';

const c3 = '<h2>天猫超市0元领：新人专享免费领取日用品大礼包</h2><p>天猫超市推出超值新人福利活动，只要是首次在天猫超市购物的用户，即可免费领取一份价值50元的日用品大礼包。</p><h3>大礼包内容</h3><p>礼包包含以下商品：维达抽纸3包装（价值15元）、蓝月亮洗衣液500g（价值20元）、高露洁牙膏2支装（价值10元）、舒肤佳香皂2块（价值5元）。所有商品均为正品，由天猫超市自营仓发货，全国包邮。</p><h3>领取步骤</h3><p>1. 下载天猫APP并注册新账号；2. 进入天猫超市频道；3. 点击"新人礼包"活动入口；4. 添加礼包商品到购物车；5. 结算时系统自动减免全部费用，实付0元。每个新用户仅限领取一次，活动截止到本月底。</p>';

const c4 = '<h2>饿了么限时免费领：新用户首单立减20元还送会员</h2><p>饿了么针对新用户推出重磅福利活动，首次下单即可享受立减20元的优惠，同时免费获得一个月饿了么超级会员资格。</p><h3>活动详情</h3><p>该活动面向从未在饿了么下过单的新用户，在APP内完成首次下单后，系统自动发放20元优惠券到账户。该优惠券<strong>全场通用、无最低消费限制</strong>，点一份15元的外卖也可使用，相当于免费吃一顿。此外，新用户还能免费获得价值15元的超级会员月卡，享受无限次免配送费的特权。</p><h3>注意事项</h3><p>优惠券自领取之日起7天内有效，超级会员自动激活，次月如需续费请手动取消。活动名额有限，建议尽快领取使用。</p>';

const c5 = '<h2>淘宝好物推荐：夏季必备防晒霜合集，均价不到30元</h2><p>夏天到了，防晒霜是每个人出门必备的单品。作为白菜好物推荐，我们整理了淘宝上目前最值得购买的几款平价防晒霜，均价不到30元，性价比爆棚。</p><h3>推荐清单</h3><p><strong>碧柔水感防晒乳</strong>（SPF50+ PA++++）：淘宝活动价25元，质地轻薄水润，适合油皮和混油皮。<strong>曼秀雷敦新碧防晒霜</strong>（SPF50+ PA++++）：活动价29元，清爽不黏腻。<strong>大宝水凝防晒露</strong>（SPF30 PA++）：国货之光，活动价仅19.9元。<strong>自然堂冰肌防晒乳</strong>（SPF50+ PA+++）：活动价35元，冰感质地清凉舒适。</p><h3>选购建议</h3><p>建议根据肤质选择适合的防晒产品，日常通勤选择SPF30即可满足需求，户外活动建议使用SPF50+的高倍防晒。记得出门前20分钟涂抹，每隔2-3小时补涂一次。</p>';

const c6 = '<h2>美团外卖大额优惠券：满30减15，每日限量领取</h2><p>美团外卖推出大额外卖红包活动，用户每日可领取一张满30元减15元的大额优惠券。这是近期外卖平台最给力的优惠活动之一，相当于直接打5折。</p><h3>领取方式</h3><p>打开美团APP，进入外卖频道，在首页轮播图中找到"每日大额券"活动入口，点击即可领取。每人每天限领一张，优惠券当天有效。建议每天上午10点准时领取，因为数量有限，通常在半小时内就会被抢光。</p><h3>使用技巧</h3><p>建议凑单到刚好30元左右，最大化优惠力度。可以和店铺自有优惠叠加使用，但不可与其他平台优惠券叠加。适用于美团外卖所有合作商家，包括餐饮、超市便利、水果生鲜等全品类。</p>';

const c7 = '<h2>耐克官方旗舰店年中大促：运动鞋低至3折</h2><p>耐克天猫官方旗舰店年中大促正式开始，全场运动鞋、运动服饰参与促销活动，折扣力度空前。多款热门鞋型低至3折起，是今年最低的价格。</p><h3>热门推荐</h3><p><strong>Air Force 1 \'07 白色经典款</strong>：原价899元，活动价<strong>299元</strong>（3.3折），男女款均有货。<strong>Nike Dunk Low Retro</strong>：原价799元，活动价359元（4.5折），多款配色可选。<strong>Nike Air Max 90</strong>：原价999元，活动价399元（4折）。</p><h3>注意事项</h3><p>以上价格均为叠加店铺优惠券和跨店满减后的到手价。部分热门款式和尺码库存有限，建议尽快下单。耐克官方旗舰店支持7天无理由退换，正品保障。</p>';

const c8 = '<h2>瑞幸咖啡0元喝：新人免费领一杯，老用户邀请好友再得一杯</h2><p>瑞幸咖啡推出最新拉新福利活动，新用户下载瑞幸咖啡APP并完成注册，即可免费获得一张任意饮品兑换券。无论是经典的美式、拿铁，还是最新的季节限定新品，均可免费兑换。</p><h3>老用户福利</h3><p>老用户同样不亏！每成功邀请一位新用户注册并完成首单，邀请人即可获得<strong>一杯免费饮品券</strong>。邀请人数上不封顶，邀请的越多获得的免费饮品券越多。</p><h3>免费饮品券说明</h3><p>免费饮品券自到账之日起30天内有效，支持所有在售饮品（含新品），不限杯型。可在瑞幸咖啡全国所有门店使用，支持到店取和外卖配送。</p>';

const c9 = '<h2>微信读书限免：畅销好书免费读，每日更新书单</h2><p>微信读书APP推出每日限时免费阅读活动，每天精选一批优质电子书供用户免费阅读。涵盖小说文学、经济管理、社会科学、励志成长等多个品类。</p><h3>今日限免书单</h3><p>今日限免书籍包括：《三体》全集（刘慈欣著）、《人类简史》（尤瓦尔·赫拉利著）、《原则》（瑞·达利欧著）、《非暴力沟通》（马歇尔·卢森堡著）等多本畅销好书。</p><h3>使用方式</h3><p>打开微信读书APP，在"发现"页面找到"限时免费"专区，即可查看当日所有限免书籍。点击书籍后选择"加入书架"即可开始阅读。限免书籍通常在24小时后恢复收费，建议添加后尽快阅读或下载到本地。</p>';

const c10 = '<h2>抖音商城超值购：日用百货全场9.9元封顶</h2><p>抖音商城"超值购"频道推出日用百货专场，所有商品价格均不超过9.9元。涵盖纸巾湿巾、收纳整理、厨房清洁、浴室用品等多个品类。</p><h3>值得购买的商品</h3><p><strong>维达抽纸6包装</strong>：9.9元包邮，每包仅1.65元。<strong>多功能收纳盒套装</strong>：5件套9.9元。<strong>厨房去油污清洁剂</strong>：500ml装9.9元。<strong>浴室防滑拖鞋</strong>：9.9元/双。<strong>旅行分装瓶套装</strong>：12件套9.9元。</p><h3>购买建议</h3><p>日用百货类商品建议适当囤货，但要注意理性消费。下单前看清商品规格和评价，部分超低价商品可能规格较小。建议优先选择标注"抖音超值购"官方标识的商品，质量和售后更有保障。</p>';

const c11 = '<h2>星巴克夏日买一送一：星冰乐系列限时特惠</h2><p>星巴克推出夏日限定优惠活动，全线星冰乐系列饮品享受买一送一特惠。无论是经典的抹茶星冰乐、摩卡星冰乐，还是季节限定的草莓星冰乐，全部参与活动。</p><h3>活动规则</h3><p>活动期间，购买任意一杯星冰乐（大杯/超大杯），即可免费获赠一杯同等或更低价格的星冰乐。活动适用于星巴克全国所有门店（部分交通枢纽门店除外），支持店内消费和小程序点单。</p><h3>推荐搭配</h3><p>推荐和好友各点一杯不同口味互相分享，一次品尝两种口味。抹茶星冰乐（35元）+ 摩卡星冰乐（33元）= 实付35元享两杯，相当于每杯仅17.5元，比平时便宜一半。</p>';

const c12 = '<h2>Keep会员免费领：7天VIP体验卡限时发放中</h2><p>Keep运动APP开启限时活动，面向所有用户免费发放7天VIP会员体验卡。领取后可解锁Keep全部付费课程、定制训练计划和专业饮食方案。</p><h3>VIP特权</h3><p>Keep VIP会员可享受以下特权：<strong>全部付费课程免费学</strong>（包括瑜伽、力量训练、HIIT等2000+课程）、<strong>个性化定制训练计划</strong>（根据你的体能和目标量身定制）、<strong>专业饮食方案</strong>（每日食谱推荐和营养分析）、<strong>专属数据报告</strong>（详细运动数据分析）。</p><h3>领取方式</h3><p>打开Keep APP，在首页找到"免费领VIP"活动入口，点击领取即可。体验卡自领取之日起7天内有效，到期后不会自动续费，可放心领取。</p>';

const c13 = '<h2>小米有品精选：米家智能家居套装白菜价299元起</h2><p>小米有品开启智能家居节活动，米家智能家居套装迎来历史最低价。入门套装仅需299元，包含智能灯泡2个、智能插座1个、温湿度传感器1个、门窗传感器1个。</p><h3>套装详情</h3><p><strong>入门套装（299元）</strong>：智能灯泡x2 + 智能插座x1 + 温湿度传感器x1 + 门窗传感器x1。<strong>进阶套装（599元）</strong>：入门套装全部 + 智能摄像头x1 + 人体传感器x2 + 无线开关x1。<strong>旗舰套装（999元）</strong>：进阶套装全部 + 智能门锁x1 + 扫地机器人x1。</p><h3>使用体验</h3><p>所有设备通过米家APP统一控制，支持小爱同学语音控制。可以设置各种自动化场景，如"离家模式"一键关闭所有灯光和电器，"回家模式"自动开灯、调节温度。真正实现智能生活触手可及。</p>';

const c14 = '<h2>新用户专享：滴滴出行首单立减15元，邀请好友各得10元</h2><p>滴滴出行面向新用户推出诚意满满的福利活动。首次使用滴滴快车或专车服务，可享受立减15元的优惠，几乎相当于免费短途出行。</p><h3>活动详情</h3><p>新用户注册滴滴出行APP后，系统自动发放一张15元无门槛优惠券到账户。该优惠券适用于<strong>快车、专车、优享</strong>等所有车型，无最低消费限制。如果行程费用不足15元，则实际支付0元，剩余优惠金额不退。</p><h3>邀请好友奖励</h3><p>除新用户福利外，滴滴还推出邀请好友活动。老用户每成功邀请一位新用户注册并完成首单，邀请人和被邀请人各得10元打车券。邀请人数上不封顶，很适合推荐给身边还没用过滴滴的朋友。</p>';

const c15 = '<h2>淘宝百亿补贴：戴森吸尘器V12直降800元，历史最低价</h2><p>淘宝百亿补贴频道再放大招，戴森吸尘器V12 Detect Slim Fluffy参与补贴活动，补贴后到手价仅为<strong>2199元</strong>，相比戴森官方2999元的售价直降800元，创下历史最低价。</p><h3>产品亮点</h3><p>戴森V12 Detect Slim是戴森最新一代无线吸尘器，配备激光探测技术，能清晰显示地面上的微尘。拥有150AW强劲吸力，整机重量仅2.2kg，轻便易用。配备多种吸头，可满足地板、地毯、沙发、床褥等多种清洁场景需求。</p><h3>购买建议</h3><p>2199元的价格对于戴森V12来说绝对是白菜价，要知道同系列的V15售价要4000+。支持花呗3期/6期免息分期，月供最低仅需367元。淘宝百亿补贴商品均为官方正品，享受戴森全国联保服务。</p>';

const c16 = '<h2>B站大会员新用户福利：首月仅需4.9元，畅享番剧</h2><p>哔哩哔哩推出新用户大会员超值体验活动，首次开通B站大会员仅需<strong>4.9元/月</strong>，即可享受大会员的所有专属特权。</p><h3>大会员特权</h3><p>B站大会员可享受：<strong>1080P+高清画质</strong>（普通用户最高720P）、<strong>抢先观看特权</strong>（部分番剧大会员可提前看一集）、<strong>专属粉色弹幕</strong>、<strong>评论表情包</strong>、<strong>空间背景装扮</strong>、<strong>年度大会员专属礼物</strong>等。</p><h3>注意事项</h3><p>4.9元首月体验价仅限新开通大会员的用户，已开通过大会员的用户不享受此优惠。首月后如需续费，按月25元，按年168元（约14元/月）。如果只想体验一个月，记得在到期前关闭自动续费。</p>';

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '京东618大促：家用电器白菜价低至9.9元，限量抢购中',
    slug: 'jd-618-jiadian-99',
    summary: '京东618年中大促火热进行中，多款家用电器降至白菜价，最低仅需9.9元即可入手。电风扇、电热水壶、吹风机等实用小家电限时秒杀，库存有限先到先得。',
    content: c1,
    category: 'baicai-jia',
    categoryName: '白菜价商品',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close-up%20product%20photography%20of%20a%20sleek%20white%20electric%20kettle%20on%20a%20minimalist%20wooden%20table%2C%20warm%20natural%20window%20light%20creating%20soft%20shadows%2C%20cream%20and%20beige%20background%2C%20modern%20kitchen%20setting%2C%20clean%20aesthetic%20composition%20with%20negative%20space%2C%20bright%20and%20airy%20atmosphere%2C%20editorial%20product%20shot%20style&width=800&height=480&seq=article-1-card&orientation=landscape',
    tags: ['京东618', '家用电器', '秒杀', '9.9元'],
    source: '京东官方活动',
    date: '2024-06-15',
    views: 15680,
    hot: true,
    featured: true,
  },
  {
    id: 'article-2',
    title: '拼多多百亿补贴再升级：iPhone 15系列直降1500元',
    slug: 'pdd-baiyi-iphone15',
    summary: '拼多多百亿补贴频道最新活动，iPhone 15系列手机迎来大幅降价，最高直降1500元。iPhone 15 128GB版本补贴后仅需4499元，刷新全网最低价记录。',
    content: c2,
    category: 'baicai-jia',
    categoryName: '白菜价商品',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20product%20shot%20of%20a%20titanium%20iPhone%2015%20Pro%20on%20a%20light%20warm-toned%20surface%2C%20minimalist%20composition%20with%20soft%20diffused%20light%2C%20cream%20background%20with%20subtle%20texture%2C%20elegant%20and%20modern%20aesthetic%2C%20high-end%20editorial%20photography%20style%2C%20no%20distractions%2C%20simple%20and%20refined&width=800&height=480&seq=article-2-card&orientation=landscape',
    tags: ['拼多多', '百亿补贴', 'iPhone', '手机'],
    source: '拼多多百亿补贴',
    date: '2024-06-14',
    views: 23450,
    hot: true,
    featured: true,
  },
  {
    id: 'article-3',
    title: '天猫超市0元领：新人专享免费领取日用品大礼包',
    slug: 'tmall-xinren-0yuan',
    summary: '天猫超市新人福利升级，新注册用户可免费领取价值50元的日用品大礼包，包含纸巾、洗衣液、牙膏等实用商品，包邮到家不花一分钱。',
    content: c3,
    category: 'lingshou-gou',
    categoryName: '0元购活动',
    imageUrl: 'https://readdy.ai/api/search-image?query=Flat%20lay%20photography%20of%20daily%20household%20essentials%20including%20tissue%20boxes%2C%20laundry%20detergent%2C%20toothpaste%20and%20soap%20arranged%20neatly%20on%20a%20light%20wooden%20surface%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20composition%2C%20lifestyle%20product%20photography%2C%20bright%20and%20airy%20mood&width=800&height=480&seq=article-3-card&orientation=landscape',
    tags: ['天猫超市', '0元购', '新人福利', '日用品'],
    source: '天猫超市官方',
    date: '2024-06-13',
    views: 31200,
    hot: true,
    featured: false,
  },
  {
    id: 'article-4',
    title: '饿了么限时免费领：新用户首单立减20元还送会员',
    slug: 'eleme-xinshou-20yuan',
    summary: '饿了么外卖新用户福利加码，首单立减20元，再送一个月超级会员。无需最低消费门槛，点多少减多少，实打实的白菜优惠不容错过。',
    content: c4,
    category: 'mianfei-lingqu',
    categoryName: '限时免费领取',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20lifestyle%20photography%20of%20delicious%20food%20delivery%20packages%20on%20a%20clean%20table%2C%20soft%20ambient%20lighting%20from%20a%20window%2C%20cream%20and%20beige%20color%20palette%2C%20cozy%20home%20atmosphere%2C%20appetizing%20food%20presentation%2C%20editorial%20food%20photography%2C%20bright%20and%20inviting%20mood&width=800&height=480&seq=article-4-card&orientation=landscape',
    tags: ['饿了么', '新人福利', '免费会员', '外卖'],
    source: '饿了么官方',
    date: '2024-06-12',
    views: 18900,
    hot: true,
    featured: false,
  },
  {
    id: 'article-5',
    title: '淘宝好物推荐：夏季必备防晒霜合集，均价不到30元',
    slug: 'taobao-fangshai-xiaji',
    summary: '夏季防晒必备清单来了！精选淘宝热销防晒霜，均价不到30元，包含安热沙、碧柔、曼秀雷敦等热门品牌。实测防晒效果好、不油腻、性价比超高。',
    content: c5,
    category: 'haowu-tuijian',
    categoryName: '白菜好物推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Flat%20lay%20beauty%20photography%20of%20sunscreen%20bottles%20arranged%20on%20a%20light%20wooden%20surface%2C%20soft%20natural%20window%20light%2C%20cream%20and%20beige%20tones%2C%20minimalist%20composition%20with%20tropical%20plant%20leaf%20as%20accent%2C%20clean%20and%20fresh%20summer%20aesthetic%2C%20editorial%20beauty%20product%20photography%2C%20bright%20airy%20mood&width=800&height=480&seq=article-5-card&orientation=landscape',
    tags: ['淘宝', '防晒霜', '好物推荐', '夏季必备'],
    source: '淘宝精选',
    date: '2024-06-11',
    views: 8900,
    hot: false,
    featured: true,
  },
  {
    id: 'article-6',
    title: '美团外卖大额优惠券：满30减15，每日限量领取',
    slug: 'meituan-dayouhui-30-15',
    summary: '美团外卖发放大额外卖优惠券，满30元立减15元，相当于5折优惠。每日限量10万张，先到先得。支持所有合作商家使用，无品类限制。',
    content: c6,
    category: 'youhuiquan',
    categoryName: '优惠券合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20illustration%20of%20a%20food%20delivery%20app%20interface%20on%20a%20smartphone%2C%20warm%20color%20palette%20with%20orange%20and%20cream%20tones%2C%20modern%20UI%20design%2C%20abstract%20representation%20of%20discount%20coupons%20floating%20around%20the%20phone%2C%20clean%20minimalist%20style%2C%20editorial%20tech%20photography%20aesthetic%2C%20bright%20and%20inviting&width=800&height=480&seq=article-6-card&orientation=landscape',
    tags: ['美团外卖', '大额优惠券', '满减', '每日福利'],
    source: '美团官方',
    date: '2024-06-10',
    views: 27800,
    hot: true,
    featured: false,
  },
  {
    id: 'article-7',
    title: '耐克官方旗舰店年中大促：运动鞋低至3折，白菜价入手',
    slug: 'nike-nianzhong-3zhe',
    summary: '耐克天猫官方旗舰店年中促销活动正式开启，多款热门运动鞋低至3折，Air Force 1经典款仅需299元，Dunk系列也参与活动，白菜价入手正品耐克。',
    content: c7,
    category: 'pinpai-huodong',
    categoryName: '品牌活动',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20classic%20white%20Nike%20Air%20Force%201%20sneakers%20on%20a%20minimal%20cream-toned%20surface%2C%20soft%20diffused%20natural%20light%20creating%20gentle%20shadows%2C%20editorial%20fashion%20aesthetic%2C%20warm%20neutral%20background%2C%20sleek%20and%20modern%20composition%2C%20lifestyle%20sneaker%20photography&width=800&height=480&seq=article-7-card&orientation=landscape',
    tags: ['耐克', '运动鞋', '3折', '品牌大促'],
    source: '耐克天猫旗舰店',
    date: '2024-06-09',
    views: 34500,
    hot: true,
    featured: true,
  },
  {
    id: 'article-8',
    title: '瑞幸咖啡0元喝：新人免费领一杯，老用户邀请好友再得一杯',
    slug: 'luckin-xinren-mianfei',
    summary: '瑞幸咖啡最新福利活动，新用户注册即可免费领取任意一杯饮品（含新品），老用户每邀请一位新用户也可免费获得一杯，上不封顶。',
    content: c8,
    category: 'lingshou-gou',
    categoryName: '0元购活动',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20lifestyle%20photography%20of%20a%20beautifully%20crafted%20latte%20with%20latte%20art%20in%20a%20ceramic%20cup%20on%20a%20wooden%20table%2C%20soft%20natural%20window%20light%2C%20cream%20and%20beige%20tones%2C%20cozy%20coffee%20shop%20atmosphere%2C%20editorial%20food%20photography%2C%20elegant%20and%20inviting%20mood%2C%20minimalist%20composition&width=800&height=480&seq=article-8-card&orientation=landscape',
    tags: ['瑞幸咖啡', '0元喝', '邀请好友', '咖啡'],
    source: '瑞幸咖啡官方',
    date: '2024-06-08',
    views: 41200,
    hot: true,
    featured: false,
  },
  {
    id: 'article-9',
    title: '微信读书限免：畅销好书免费读，每日更新书单',
    slug: 'weread-xianmian-shudan',
    summary: '微信读书APP每日更新限时免费书单，涵盖小说、经管、社科、励志等多品类畅销书籍。不花一分钱读好书，每日更新不容错过。',
    content: c9,
    category: 'mianfei-lingqu',
    categoryName: '限时免费领取',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20photography%20with%20an%20e-reader%20device%20on%20a%20warm%20wooden%20table%2C%20soft%20natural%20light%20from%20a%20window%2C%20cream%20and%20beige%20color%20palette%2C%20comfortable%20chair%20in%20background%2C%20peaceful%20atmosphere%2C%20lifestyle%20photography%2C%20editorial%20mood%2C%20warm%20and%20inviting&width=800&height=480&seq=article-9-card&orientation=landscape',
    tags: ['微信读书', '限时免费', '好书推荐', '阅读'],
    source: '微信读书官方',
    date: '2024-06-07',
    views: 12300,
    hot: false,
    featured: false,
  },
  {
    id: 'article-10',
    title: '抖音商城超值购：日用百货全场9.9元封顶',
    slug: 'douyin-riyong-99',
    summary: '抖音商城推出超值购专区，日用百货全场9.9元封顶。纸巾、收纳盒、清洁工具等生活必需品超低价，买多件也不心疼，囤货党的狂欢。',
    content: c10,
    category: 'baicai-jia',
    categoryName: '白菜价商品',
    imageUrl: 'https://readdy.ai/api/search-image?query=Flat%20lay%20photography%20of%20colorful%20household%20items%20including%20tissue%20boxes%2C%20storage%20containers%20and%20cleaning%20supplies%20arranged%20neatly%20on%20a%20light%20wooden%20table%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20organized%20and%20tidy%20composition%2C%20lifestyle%20product%20photography%2C%20bright%20and%20clean%20aesthetic&width=800&height=480&seq=article-10-card&orientation=landscape',
    tags: ['抖音商城', '9.9元', '日用百货', '超值购'],
    source: '抖音商城',
    date: '2024-06-06',
    views: 19800,
    hot: true,
    featured: false,
  },
  {
    id: 'article-11',
    title: '星巴克夏日买一送一：星冰乐系列限时特惠',
    slug: 'starbucks-maiyisongyi',
    summary: '星巴克夏日特惠活动，全线星冰乐系列买一送一。抹茶星冰乐、摩卡星冰乐、草莓星冰乐等热门口味均参与活动，约上朋友一起享受夏日清凉。',
    content: c11,
    category: 'lingshou-gou',
    categoryName: '0元购活动',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20food%20photography%20of%20two%20colorful%20Starbucks%20Frappuccinos%20side%20by%20side%20on%20a%20clean%20table%2C%20soft%20summer%20natural%20light%2C%20cream%20and%20beige%20tones%2C%20refreshing%20green%20matcha%20and%20chocolate%20brown%20colors%2C%20lifestyle%20cafe%20photography%2C%20bright%20and%20vibrant%20mood%2C%20editorial%20composition&width=800&height=480&seq=article-11-card&orientation=landscape',
    tags: ['星巴克', '星冰乐', '买一送一', '夏日特惠'],
    source: '星巴克官方',
    date: '2024-06-05',
    views: 28700,
    hot: true,
    featured: false,
  },
  {
    id: 'article-12',
    title: 'Keep会员免费领：7天VIP体验卡限时发放中',
    slug: 'keep-vip-mianfei',
    summary: 'Keep运动APP免费发放7天VIP体验卡，可解锁全部付费课程、定制训练计划和饮食方案。零成本体验专业健身指导，限量领取中。',
    content: c12,
    category: 'mianfei-lingqu',
    categoryName: '限时免费领取',
    imageUrl: 'https://readdy.ai/api/search-image?query=Motivational%20fitness%20photography%20of%20a%20yoga%20mat%20and%20water%20bottle%20on%20a%20light%20wooden%20floor%2C%20soft%20natural%20light%20from%20large%20windows%2C%20cream%20and%20beige%20color%20palette%2C%20clean%20minimalist%20gym%20space%2C%20wellness%20lifestyle%20aesthetic%2C%20bright%20and%20energizing%20mood%2C%20editorial%20sports%20photography&width=800&height=480&seq=article-12-card&orientation=landscape',
    tags: ['Keep', '免费会员', '健身体验', 'VIP'],
    source: 'Keep官方',
    date: '2024-06-04',
    views: 9600,
    hot: false,
    featured: false,
  },
  {
    id: 'article-13',
    title: '小米有品精选：米家智能家居套装白菜价299元起',
    slug: 'xiaomi-zhineng-jiaju',
    summary: '小米有品智能家居节，米家智能家居套装低至299元起。包含智能灯泡、智能插座、温湿度传感器等，轻松打造智能家庭，性价比极高。',
    content: c13,
    category: 'baicai-jia',
    categoryName: '白菜价商品',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20smart%20home%20scene%20with%20smart%20LED%20bulbs%2C%20smart%20plug%2C%20and%20sensors%20arranged%20on%20a%20warm%20wooden%20surface%2C%20soft%20ambient%20lighting%2C%20cream%20and%20beige%20tones%2C%20minimalist%20tech%20lifestyle%20aesthetic%2C%20clean%20and%20organized%20composition%2C%20editorial%20product%20photography%2C%20warm%20and%20inviting%20mood&width=800&height=480&seq=article-13-card&orientation=landscape',
    tags: ['小米有品', '智能家居', '米家', '套装'],
    source: '小米有品官方',
    date: '2024-06-03',
    views: 14500,
    hot: true,
    featured: false,
  },
  {
    id: 'article-14',
    title: '新用户专享：滴滴出行首单立减15元，邀请好友各得10元',
    slug: 'didi-xinren-15yuan',
    summary: '滴滴出行新用户福利，首次使用快车/专车服务立减15元。同时邀请好友活动升级，邀请人和被邀请人各得10元打车券，上不封顶。',
    content: c14,
    category: 'xinshou-zhuanqu',
    categoryName: '新手专区',
    imageUrl: 'https://readdy.ai/api/search-image?query=Urban%20mobility%20photography%20of%20a%20clean%20modern%20car%20interior%20viewed%20through%20window%2C%20soft%20natural%20light%2C%20warm%20cream%20and%20beige%20tones%2C%20comfortable%20seat%20texture%20visible%2C%20lifestyle%20transportation%20aesthetic%2C%20editorial%20mood%2C%20bright%20and%20clean%20composition%2C%20city%20backdrop%20subtly%20blurred&width=800&height=480&seq=article-14-card&orientation=landscape',
    tags: ['滴滴出行', '新用户', '立减', '打车券'],
    source: '滴滴出行官方',
    date: '2024-06-02',
    views: 17600,
    hot: false,
    featured: false,
  },
  {
    id: 'article-15',
    title: '淘宝百亿补贴：戴森吸尘器V12直降800元，历史最低价',
    slug: 'taobao-dyson-v12',
    summary: '淘宝百亿补贴频道上线戴森吸尘器V12 Detect Slim，补贴后价格仅为2199元，相比官方售价直降800元。支持花呗分期免息，性价比极高。',
    content: c15,
    category: 'baicai-jia',
    categoryName: '白菜价商品',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20sleek%20Dyson%20cordless%20vacuum%20cleaner%20standing%20on%20a%20light%20wooden%20floor%2C%20soft%20natural%20light%2C%20cream%20and%20beige%20tones%2C%20modern%20home%20interior%2C%20minimalist%20composition%2C%20editorial%20product%20shot%2C%20bright%20and%20airy%20mood%2C%20premium%20appliance%20photography&width=800&height=480&seq=article-15-card&orientation=landscape',
    tags: ['淘宝', '百亿补贴', '戴森', '吸尘器'],
    source: '淘宝百亿补贴',
    date: '2024-06-01',
    views: 22100,
    hot: true,
    featured: true,
  },
  {
    id: 'article-16',
    title: 'B站大会员新用户福利：首月仅需4.9元，畅享番剧',
    slug: 'bilibili-xinren-49',
    summary: '哔哩哔哩大会员新用户专享福利，首月仅需4.9元即可体验大会员全部特权。高清画质、抢先观看、专属弹幕等全部解锁，动漫爱好者的福音。',
    content: c16,
    category: 'xinshou-zhuanqu',
    categoryName: '新手专区',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20illustration%20of%20a%20colorful%20entertainment%20streaming%20interface%20on%20a%20laptop%20screen%2C%20warm%20ambient%20lighting%2C%20cream%20and%20beige%20background%20tones%2C%20anime-inspired%20visual%20elements%2C%20modern%20tech%20lifestyle%20aesthetic%2C%20cozy%20desk%20setup%2C%20editorial%20mood%2C%20inviting%20and%20vibrant&width=800&height=480&seq=article-16-card&orientation=landscape',
    tags: ['B站', '大会员', '新用户', '番剧'],
    source: '哔哩哔哩官方',
    date: '2024-05-31',
    views: 25500,
    hot: false,
    featured: false,
  },
];